import script from "./Pegman.vue?vue&type=script&setup=true&lang=ts"
export * from "./Pegman.vue?vue&type=script&setup=true&lang=ts"

import "./Pegman.vue?vue&type=style&index=0&id=6766cddc&lang=css"

const __exports__ = script;

export default __exports__